import React, { useState } from "react";
import firebase from "./../../../firebase";
import {useDispatch,useSelector} from "react-redux";
import * as authActions from  "../../../store/actions/authActions"
import {authFeatureKey} from "../../../store/featureKeys";
import {connectUser,disconnectUser} from "../../../store/actions/authActions";

// wallet connect
import { Web3ReactProvider, useWeb3React } from "@web3-react/core";
import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Web3 from "web3";
import { Web3Provider } from "@ethersproject/providers";
import Web3Modal from "web3modal";
import { providers } from "ethers";

//import { DataStore } from "@aws-amplify/datastore";
import { USER } from "../../../models";
import { connect } from "react-redux";
import { newUser } from "../../../redux/actions";

//registration poppup
import RegisterPopup from "../../../pages/home/sections/registerPopup/RegisterPopup";
import Profile from "../../../pages/profile/Profile";
import { Link } from "react-router-dom";

// Stylesheet
import "./WalletPopup.css";
import profile from "../../../assets/Profile.png";

// Popup
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// Assets
import wallet from "../../../assets/Wallet.png";
import walletPopup1 from "../../../assets/walletPopup1.png";
import walletPopup2 from "../../../assets/walletPopup2.png";

function getLibrary(provider) {
  const library = new Web3Provider(provider);
  library.pollingInterval = 12000;
  return library;
}

const metaMask = new InjectedConnector({
  supportedChainIds: [1, 4,80001],
});

const walletConnect = new WalletConnectConnector({
  supportedChainIds: [1, 4],
  qrcode: true,
});

export let acc = 0;

function WalletPopup({ newUser }) {

  let dispatch = useDispatch()
  const {openConnectModal,isConnected} = useSelector(state=>{
    return state[authFeatureKey]
  })
  const [open, setOpen] = React.useState(false);
  //const [a,setacc] = React.useState("");

  const web3Modal = new Web3Modal({ cacheProvider: true });
  // useEffect to connect while load!!
  const [tried, setTried] = React.useState(false);
  const [dropDown, setDropDown] = useState(false);

  const [Web3Pro, setWeb3Pro] = useState(null);
  const [account, setAccount] = useState("");
  const [provider, setProvider] = useState(null);
  React.useEffect(() => {
    document.addEventListener("click", printMousePos, true);
    if (web3Modal.cachedProvider) {
      connectMM();
      console.log("connectMMMMM");
    }
    /*     metaMask.isAuthorized().then((isAuthorized) => {
      if (isAuthorized) {
        activate(metaMask, undefined, true).catch(() => {
          setTried(true);
        });
      } else {
        setTried(true);
      }
    }); */
  }, []);

  const [registerForm, setregisterForm] = React.useState(false);
  // const { chainId,active, account, library, connector, activate, deactivate } = useWeb3React()
  // { active ? console.log(library) : console.log('wallet not connected yet') }

  const [activatingConnector, setActivatingConnector] = React.useState("");
  // React.useEffect(() => {
  //   if (activatingConnector && activatingConnector === connector) {
  //     setActivatingConnector(undefined)
  //   }
  // }, [])

  // handle logic to connect in reaction to certain events on the injected ethereum provider, if it exists

  //for closing dropdown when clicked somewhere else
  function printMousePos(e) {
    let cursorX = e.pageX;
    let cursorY = e.pageY;
    const component = document.elementFromPoint(cursorX, cursorY);
    if (component && component.classList.value !== "__dropDown__") {
      setDropDown(false);
    }
  }

  const handleClickOpen = () => {
    setOpen(true);
    dispatch(authActions.openConnectModal())
  };

  const handleClose = () => {
    console.log("handleClose")
    setOpen(false);
    dispatch(authActions.closeConnectModal())
  };

  const handleDropDown = () => {
    const _dropDown = !dropDown;
    setDropDown(_dropDown);
  };

  React.useEffect(() => {
    const { ethereum } = window;
    if (ethereum && ethereum.on && !Web3Pro) {
      const handleChainChanged = async (chainId) => {
        alert("Chain Changed!!");
        // console.log("Handling 'chainChanged' event with payload !", chainId)
        connectMM();
        //  window.location.reload();
        // <profile></profile>
        
        

      };
      const handleAccountsChanged = (accounts) => {
        alert("Account Changed!!");
        //console.log("Handling 'accountsChanged' event with payload", accounts)
        if (accounts.length > 0) {
          connectMM();
          // window.location.reload();
          // <profile></profile>
        }
      };
      // ethereum.on('connect', handleConnect)
      ethereum.on("chainChanged", handleChainChanged);
      ethereum.on("accountsChanged", handleAccountsChanged);

      return () => {
        if (ethereum.removeListener) {
          // ethereum.removeListener('connect', handleConnect)
          ethereum.removeListener("chainChanged", handleChainChanged);
          ethereum.removeListener("accountsChanged", handleAccountsChanged);
        }
      };
    }
  }, []);
  // wallet connect functions
  async function connectMM() {
    try {
      const web3 = new Web3(window.ethereum);
      console.log("dkcnsdjvnnsdjvb ")
      const chainIds = await web3.eth.getChainId();

      if (chainIds === 1 || chainIds === 4 || chainIds === 80001) {
        const web3Modal = new Web3Modal({ cacheProvider: true });
        var provider1 = await web3Modal.connect();
       
        const web3Provider = new providers.Web3Provider(provider1);
       
        const signer = web3Provider.getSigner();
       
        const address = await signer.getAddress();
       
        setWeb3Pro(web3Provider);
        setAccount(address);
        setProvider(provider1);
        console.log();
        //await checkDb();
        handleClose();
        // setacc(account);
        // console.log(account);
        dispatch(authActions.connectUser(address,provider1));
        newUser(address);
        console.log(address);
        checkDb(address);
      
      } else {
        alert("Wrong Network " + chainIds);
        try {
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            // change the chain Id once you want to have Polygon Mainnet and change all the config also over here!!
            params: [{ chainId: '0x13881' }],
          });
        } catch (e) {
          if (e.code === 4902) {
            try {
              await window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [
                  {
                    chainId: '0x13881',
                    chainName: 'Polygon Mumbai',
                    nativeCurrency: {
                      name: 'MATIC',
                      symbol: 'MATIC', // 2-6 characters long
                      decimals: 18
                    },
                  
                    rpcUrls: ['https://rpc-mumbai.maticvigil.com/'],
                  },
                ],
              });
            } catch (addError) {
              console.error(addError);
            }
          }
          // console.error(e)
        }
      }
    } catch (err) {
      //ntcon();
      console.log(err);
    }
  }
  async function connectWC() {
    try {
      // const web3 = new Web3(window.ethereum);
      // const chainIds = await web3.eth.getChainId();

      
        const providerOptions = {
          walletconnect: {
            package: WalletConnectProvider, // required
            options: {
              // Change the mainnet infura id over here
              infuraId: "https://mainnet.infura.io/v3/e70043e2eaa94464a303615284d7d2d4" // required
            }
          }
        };
        
        const web3Modal = new Web3Modal({ cacheProvider: true,providerOptions });
         var provider1 = await web3Modal.connectTo("walletconnect");
         console.log(provider1);
        const web3 = new Web3(provider1);
        const a = await web3.eth.getAccounts();
        console.log(a);
        const web3Provider = new providers.Web3Provider(provider1);
        const signer = web3Provider.getSigner();
        const address = await signer.getAddress();
        setWeb3Pro(web3Provider);
        setAccount(address);
        setProvider(provider1);
        //await checkDb();
        handleClose();
        // setacc(account);
        // console.log(account);
        dispatch(authActions.connectUser(address,provider1))
        newUser(address);
        console.log(address);
        checkDb(address);
        console.log(provider);
      
    } catch (err) {
      //ntcon();
      console.log(err);
    }
  }

  /*   async function connectWC() {
    try {
      if (!active) {
        await activate(walletConnect);
        handleClose();
        // checkDb(2);
      } else {
        alert("Already connected!!");
      }
    } catch (err) {
      console.log(err);
    }
  }
  async function connectCB() {
    try {
      if (!active) {
        await activate(coinbase);
        handleClose();
        //checkDb(3);
        console.log(account);
      } else {
        alert("Already Connected!!");
      }
    } catch (err) {
      console.log(err);
    }
  }
*/

  async function handleDisconnect() {
    web3Modal.clearCachedProvider();
    newUser("");
    dispatch(authActions.disconnectUser())
    setAccount("");
    setWeb3Pro(null);
    setProvider(null);
    if (provider?.disconnect && typeof provider.disconnect === "function") {
      await provider.disconnect();
      console.log("Disconnected");
    }
    //setuserData({})
    setregisterForm(false);
  }

  async function checkDb(user) {
    await firebase
      .firestore()
      .collection("UserDataModel")
      .where("walletAddress", "==", `${user}`)
      .get()
      .then((querySnapshot) => {
        setregisterForm(querySnapshot.empty);
      })
      .catch((error) => {});
    // const models = await DataStore.query(USER, (c) =>
    //   c.Wallet_Address("eq", `${account}`)
    // );
    // console.log("models");

    // console.log(models);
    // try {
    //   localStorage.setItem("user", 1);
    // } catch (e) {
    //   console.log(e);
    // }

    // if (models.length === 0) {
    //   setregisterForm(true);
    //   // console.log("need to register!!");
    // } else {
    //   setregisterForm(false);
    //   // console.log("Already this register!!");
    // }
  }

  return (
    <div>
      {registerForm ? (
        <RegisterPopup account={account} />
      ) : (
        console.log("no register!!")
      )}

      {!Web3Pro ? (
        <Button className="wallet-button" onClick={handleClickOpen}>
          <img src={wallet} alt="wallet" className="header-icon" />
        </Button>
      ) : (
        <div
          style={{
            position: "relative",
          }}
        >
          <div onClick={handleDropDown}>
            <img src={profile} alt="profile" className="header-icon" />
          </div>
          <div
            className="__dropDown__"
            style={{
              display: !dropDown ? "none" : "initial",
              position: "absolute",
              right: "50%",
              transform: "translateX(50%)",
              padding: "0.6rem 2rem",
              fontSize: "1.2rem",
              backgroundColor: "white",
              textAlign: "center",
              borderRadius: "10px",
              cursor: "default",
              zIndex: 200,
            }}
          >
            {account && (
              <div style={{ margin: "0.5rem 0", color: "black" }}>
                {account.substr(0, 4) +
                  ".................." +
                  account.slice(-4)}
              </div>
            )}
            <Link style={{ color: "black" }} to="/profile">
              <div
                style={{
                  margin: "0.5rem 0",
                }}
              >
                Profile
              </div>
            </Link>
            <Link style={{ color: "black" }} to="/">
              <div style={{ margin: "0.5rem 0" }} onClick={handleDisconnect}>
                Disconnect
              </div>{" "}
            </Link>
          </div>
        </div>
      )}
      <Dialog
        open={openConnectModal}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle className="popup popup-title" id="responsive-dialog-title">
          {"Wallet"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="popup popup-content">
            Connect with one of our available wallet
          </DialogContentText>
        </DialogContent>
        <DialogActions className="wallet-options defined-width">
          <a
            href="#"
            className="wallet-option wallet-option-1"
            onClick={()=>connectMM()}
          >
            <img src={walletPopup1} alt="wallet" />
            <span style={{ margin: "0 auto" }}>MetaMask</span>
          </a>
          <a
            href="#"
            className="wallet-option wallet-option-2"
              onClick={connectWC} 
          >
            <img src={walletPopup2} alt="wallet" />
            <span style={{ margin: "0 auto" }}>Wallet Connect</span>
          </a>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => ({ state: state.currentUser });
// dispatch(authActions.connectUser(address))
export default connect(mapStateToProps, { newUser })(function ({ newUser }) {
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <WalletPopup newUser={newUser} />
    </Web3ReactProvider>
  );
  
});

export { providers };